import { render, staticRenderFns } from "./NewPickup.vue?vue&type=template&id=735dfc11&"
import script from "./NewPickup.vue?vue&type=script&lang=js&"
export * from "./NewPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports